import { Component } from '@angular/core';

@Component({
  selector: 'op-footer',
  imports: [],
  templateUrl: './footer.html',
  styleUrl: './footer.css',
})
export class Footer {

}
